export const MAX_TITLE_SPACING_PER_LINE = 50;
export const MAX_IFP_DESCRIPTION_SPACING_PER_LINE = 35;

export const BODY_S_MEDIUM_LINE_HEIGHT = 24;

export const BODY_M_DEMI_LINE_HEIGHT = 28;
